import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';
import { PaginationUtil } from 'ng-jhipster';

import { EventReservationPopupComponent } from './event-reservation-dialog.component';
import { EventReservationDeletePopupComponent } from './event-reservation-delete-dialog.component';
import { EventReservationPayPopupComponent } from './event-reservation-pay-dialog.component';
import { EventReservationComponent } from './event-reservation.component';


@Injectable()
export class EventReservationResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'begining, desc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}


export const eventReservationRoute: Routes = [
    {
        path: 'event-reservation',
        component: EventReservationComponent,
        resolve: {
            'pagingParams': EventReservationResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.eventReservation.home.title'
        }
    }

];

export const eventReservationPopupRoute: Routes = [
   {
        path: 'event-reservation-new',
        component: EventReservationPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.eventReservation.home.title'
        },
        outlet: 'popup'
   },
   {
           path: 'new-event-reservation-for-event/:eventId',
           component: EventReservationPopupComponent,
           data: {
               authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ],
               pageTitle: 'jYoguiApp.eventReservation.home.title'
           },
           outlet: 'popup'
       },
   {
        path: 'event-reservation/:id/edit',
        component: EventReservationPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_ADVANCED_TEACHER'],
            pageTitle: 'jYoguiApp.eventReservation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'event-reservation/:id/delete',
        component: EventReservationDeletePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_ADVANCED_TEACHER'],
            pageTitle: 'jYoguiApp.eventReservation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'event-reservation/:id/pay',
        component: EventReservationPayPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.eventReservation.home.title'
        },
        outlet: 'popup'
    }
];





// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation.route.ts